import { cn } from "@/lib/utils";
import { VariantProps, cva } from "class-variance-authority";
import React from "react";

export const buttonVariants = cva(
  "bg-gradient-to-b from-[#1E1D24] to-[#14121A] rounded-full cursor-pointer  border border-primaryborder text-[#B1B0B2] font-medium hover:scale-[97%] hover:opacity-90 transition-all duration-300",
  {
    variants: {
      variant: {
        default: "",
        glowRed:
          "bg-[#DD2928] text-white border border-[#FF6447] shadow-[0_0_8px_1px_#FF2800] max-md:shadow-[0_0_10px_-2px_#FF2800]",
        glowBlue:
          "bg-blue-500 text-white border border-blue-400 shadow-[0_0_8px_1px_#007AFF] max-md:shadow-[0_0_10px_-2px_#007AFF]",
        glowGreen:
          "bg-green-500 text-white border border-green-400 shadow-[0_0_8px_1px_#00FF00] max-md:shadow-[0_0_10px_-2px_#00FF00]",
        glowPurple:
          "bg-[#800080] text-white border border-[#a703a7] shadow-[0_0_8px_1px_#800080] max-md:shadow-[0_0_10px_-2px_#800080]",
      },
      size: {
        sm: "px-3 py-1 text-xs",
        md: "size-[36px]",
        lg: "size-[64px]",
        default: "px-[20px] py-[10px] text-sm text-nowrap max-md:text-xs",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const GlowButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, size, variant, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(buttonVariants({ variant, size }), className)}
        {...props}
      >
        {children}
      </button>
    );
  }
);

GlowButton.displayName = "GlowButton";
